import angular from 'angular';
import uiRouter from '@uirouter/angularjs';
import moment from 'angular-moment';
import routing from './monthly_active_report.routes';

import DailyActivePowerService from '../../../components/api/daily_active_power/daily_active_power.service';
import ActivePowerService from '../../../components/api/active_power/active_power.service';
import WeatherService from '../../../components/api/weather/weather.service';
import DailyWeatherService from '../../../components/api/daily_weather/daily_weather.service';
import CompareWeatherLogic from '../../../components/logic/compare_weather/compare_weather.logic';
import PowerFormatter from '../../../components/logic/power-formatter/power-formatter.logic';
import Chart from '../../../components/directive/chart/chart.directive';
import DateUtil from '../../../components/logic/date_util/date_util.module';
import CsvUtil from '../../../components/logic/csv_util/csv.util';
import chartConfig from './monthly_active_report.config';

export class MonthlyActiveReportController {
  /*@ngInject*/
  constructor($stateParams, $filter, $state, $q, moment, PowerFormatter, DailyActivePowerService, ActivePowerService, DateUtil, CsvUtil, WeatherService, DailyWeatherService, CompareWeatherLogic) {
    this.id = $stateParams.id;
    this.$filter = $filter;
    this.$state = $state;
    this.$q = $q;
    this.DailyActivePowerService = DailyActivePowerService;
    this.ActivePowerService = ActivePowerService;
    this.WeatherService = WeatherService;
    this.DailyWeatherService = DailyWeatherService;
    this.CompareWeatherLogic = CompareWeatherLogic;
    this.PowerFormatter = PowerFormatter;
    this.DateUtil = DateUtil;
    this.CsvUtil = CsvUtil;
    this.moment = moment;

    let today = this.moment();
    this.targetDate = $stateParams.target || today.toDate();
    $stateParams.target = null;

    this.maxDate = this.moment().startOf('day').toDate();

    this.downloadFileName = 'active_power_daily.csv';
    this.bulkDownloadFileName = 'active_power_hourly.csv';
    this.bulkCsvGenerator = () => {
      return this.createBulkCsv();
    };
    this.downloading = false;

    this.categories = [];
    this.chartConfig = chartConfig(this);
  }

  $onInit() {
    this.parentComponent.saConfigPromise.then(config => {
      this.billingDay = config.billing_date;
      this.updateGraph(this.targetDate, this.billingDay);
    });
  }

  updateGraph(targetDate, billingDate) {
    [this.startDate, this.endDate] = this.DateUtil.getBillingDateDomain(targetDate, billingDate);

    this.billingDate = this.moment(this.endDate).add(1, 'days').toDate();
    let numberOfDays = (this.endDate - this.startDate) / (24 * 60 * 60 * 1000);

    let startUtc = this.DateUtil.localToUTC(this.startDate);
    this.categories = [];
    for (let i = 0; i <= numberOfDays; i++) {
      this.categories.push(this.DateUtil.leapDate(startUtc, i).valueOf());
    }

    const powerQuery = angular.extend({id: this.id}, this.DateUtil.getDateRangeQueries(this.startDate, this.endDate));
    const weatherQuery = angular.extend({sa_config_id: this.id}, this.DateUtil.getDateRangeQueries(this.startDate, this.endDate));

    this.$q.all([
      this.DailyActivePowerService.show(powerQuery).$promise,
      this.DailyWeatherService.api.index(weatherQuery).$promise
    ]).then(responses => {
      const powers = responses[0];
      const weathers = responses[1];

      this.activePowerObjects = this.PowerFormatter.formatDailyActivePowers(powers.powers, this.categories);
      this.activePowers = this.activePowerObjects.map(power => {return power.y});

      this.weathers = this.CompareWeatherLogic.compareDaily(weathers, this.categories);
      const y = (this.weathers.length > 0) ? 36 : null;

      this.chart.xAxis[0].update({
        categories: this.categories,
        max: numberOfDays,
        labels: {y: y}
      });
      this.itemWidth = 100 / numberOfDays;

      this.csvData = this.CsvUtil.processDailyActivePower(this.activePowers, this.categories, this.weathers);
      this.chart.series[0].setData(this.activePowerObjects);
      this.chart.reflow();

      const date = this.moment(targetDate);
      this.downloadFileName = date.format('[active_power_]YYYY-MM[_daily.csv]');
      this.bulkDownloadFileName = date.format('[active_power_]YYYY-MM[_hourly.csv]');
    });
  }

  createBulkCsv() {
    this.downloading = true;
    let startDate = this.moment(this.startDate);
    let endDate = this.moment(this.endDate).add(1, 'day');

    const powerQuery = angular.extend(
      this.DateUtil.datetimeRangeQuery(startDate, endDate),
      {
        id: this.id,
        start_min: 0
      }
    );
    const weatherQuery = angular.extend({sa_config_id: this.id}, this.DateUtil.getDateRangeQueries(startDate, endDate.subtract(1, 'day')));

    return new Promise(resolve => {
      this.$q.all([
        this.ActivePowerService.show(powerQuery).$promise,
        this.WeatherService.api.index(weatherQuery).$promise
      ]).then(responses => {
        resolve(this.CsvUtil.processBulkActivePower(responses[0].powers, responses[1]));
        this.downloading = false;
      });
    });
  }

  changeMonth(diff) {
    this.targetDate = this.moment(this.targetDate).add(diff, 'months').toDate();

    this.updateGraph(this.targetDate, this.billingDay);
  }
}

export default angular.module('leptonApp.monthlyActiveReport', [uiRouter, moment, Chart, PowerFormatter, DailyActivePowerService, ActivePowerService, DateUtil, CsvUtil, WeatherService, DailyWeatherService, CompareWeatherLogic])
  .config(routing)
  .component('monthlyActiveReport', {
    require: {parentComponent: '^demandReportShow'},
    template: require('./monthly_active_report.html'),
    controller: MonthlyActiveReportController
  })
  .name;



// WEBPACK FOOTER //
// ./public/dev/app/active_report/monthly/monthly_active_report.component.js